/**
 * Comutatorul intregii suprafete de PAROLA din autentificare (lansarea 21.09).
 *
 * Decizia owner-ului din 18.09: nu mai exista conceptul de parola, pentru nimeni — toti intra cu
 * e-mail + cod unic. Codul construit **nu se arunca**: ramane in bundle, sub flagul asta, oprit.
 *
 * Ce ascunde, cand e oprit: cardul de conectare cu parola + butonul Google de pe `/autentificare`,
 * «Am uitat parola», rutele `/am-uitat-parola`, `/confirmare-resetare`, `/schimba-parola`, si
 * intrarea «Schimbare parola» din meniul de utilizator.
 *
 * 🔴 Scris EXACT asa, fara cast si fara acces indirect: Vite inlocuieste TEXTUAL
 * `import.meta.env.VITE_...` la build. Forma `(import.meta as {...}).env?.VITE_...` multumeste
 * TypeScript, dar nu se mai potriveste la inlocuire, deci in bundle ramane `undefined` si flagul
 * e mereu oprit — capcana platita deja la U4 si la p8.
 *
 * ⚠️ `ImportMetaEnv` are `[key: string]: any`, deci un typo in nume compileaza si devine
 * `undefined` la runtime. De-aia numele apare o SINGURA data in cod: aici.
 *
 * ⚠️ Un flag `VITE_*` e garda la RULARE, nu eliminare de cod: ramurile oprite raman in bundle.
 * Dovada ca ecranul de parola e dormant e COMPORTAMENTUL (sonda pe ecran), nu un grep pe `dist/`.
 */
export const AUTH_PAROLA_ACTIVA =
    String(import.meta.env.VITE_AUTH_PAROLA ?? '').toLowerCase() === 'true';
